import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    forms: {},
};

const formSlice = createSlice({
    name: "form",
    initialState, 
    reducers: {
        updateField: (state, action) => {
            const {formId, fieldName, value} = action.payload;

            if (!state.forms[formId]) {
                state.forms[formId] = {values: {}, errors: {}}
            }

            state.forms[formId].values[fieldName] = value;
        },
        setFieldError: (state, action) => {
            const {formId, fieldName, error} = action.payload;

            if (!state.forms[formId]) {
                state.forms[formId] = {values: {}, errors: {}};
            }

            state.forms[formId].errors[fieldName] = error;
        },
        setFieldValidationState: (state, action) => {
            const {formId, fieldName, isEmpty} = action.payload;

            if (!state.forms[formId]) {
                state.forms[formId] = {values: {}, errors: {}, validationState: {}};
            }

            if (!state.forms[formId].validationState) {
                state.forms[formId].validationState = {};
            }

            state.forms[formId].validationState[fieldName] = isEmpty;
        },
        clearFieldError: (state, action) => {
            const {formId, fieldName} = action.payload;
            if (state.forms[formId]) {
                delete state.forms[formId].errors[fieldName];
            }
        },
        clearForm: (state, action) => {
            const {formId} = action.payload ?? {};

            if (!formId) {
                return;
            }

            delete state.forms[formId];
        },
        setFormErrors: (state, action) => {
            const {formId, errors} = action.payload;
            if (!state.forms[formId]) {
                state.forms[formId] = {values: {}, errors: {}};
            }
            state.forms[formId].errors = {...errors};
        },
        clearFormErrors: (state, action) => {
            const {formId} = action.payload;
            if (state.forms[formId]) {
                state.forms[formId].errors = {};
            }
        }
    }
})

export const { updateField, setFieldError, clearFieldError, clearForm, setFieldValidationState, setFormErrors, clearFormErrors} = formSlice.actions;

export default formSlice.reducer;